import { ADD_NOTIFICATION } from './actionTypes';

export function addNotification(message, level, optParams = {}) {
  const notification = Object.assign({}, { message, level }, optParams);
  return {
    type: ADD_NOTIFICATION,
    payload: {
      notification,
    },
  };
}

export default {};



// WEBPACK FOOTER //
// ./src/services/notification/action.js